import React from 'react';
import { Link } from 'react-router-dom';

const BrandMark: React.FC = () => (
  <svg
    className="cp-marketing-brand-mark"
    viewBox="0 0 48 32"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    focusable="false"
  >
    <path
      className="cp-marketing-brand-mark-range"
      d="M2 28 14 12 22 20 30 8 46 28Z"
    />
    <path
      className="cp-marketing-brand-mark-peak"
      d="M8 28 20 10 28 18 36 4 42 28Z"
    />
  </svg>
);

interface MarketingBrandProps {
  linkTo?: string;
}

const MarketingBrand: React.FC<MarketingBrandProps> = ({ linkTo = '/' }) => {
  const lockup = (
    <div className="cp-marketing-brand" aria-label="Crowpeaks">
      <div className="cp-marketing-brand-lockup">
        <BrandMark />
        <span className="cp-marketing-brand-wordmark">
          <span className="cp-marketing-brand-crow">Crow</span>
          <span className="cp-marketing-brand-peaks">peaks</span>
        </span>
      </div>
    </div>
  );

  return <Link to={linkTo}>{lockup}</Link>;
};

export default MarketingBrand;
